import { useState, useEffect } from "react";

import api from "../../../api/api";
import HintModal from "../common/hint-modal";

import useGetClientPortalSettings from "./hooks/useEditClientPortal";

const ClientPortal = () => {
  // const heading = "FIRM SETTINGS TITLE WITH CENTERED TEXT";
  const points = [
    "Firm settings panel instruction point one",
    "Firm settings panel instruction point two",
    "Firm settings panel instruction point three",
  ];

  const { data, refetch } = useGetClientPortalSettings();

  const [formState, setFormState] = useState({
    brandColor: "#0eddcf",
    headerFontStyle: "Arial",
    sidebarFontStyle: "Arial",
  });
  const [showHints, setShowHints] = useState(false);

  const handleHintToggle = () => {
    setShowHints(!showHints);
  };

  const FontSettings = [
    {
      id: 1,
      name: "Arial",
    },
    {
      id: 2,
      name: "Times New Roman",
    },
    {
      id: 3,
      name: "Courier New",
    },
    {
      id: 4,
      name: "Georgia",
    },
    {
      id: 5,
      name: "Helvetica",
    },
  ];

  useEffect(() => {
    if (data) {
      setFormState({
        brandColor: data.brand_color || "#0eddcf",
        headerFontStyle: data.header_font_style || "Arial",
        sidebarFontStyle: data.sidebar_font_style || "Arial",
      });
    }
  }, [data]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    try {
      const response = await api.post("/api/firmsetting-page/edit-clientportal-settings/", {
        brandColor: formState.brandColor,
        headerFontSelect: formState.headerFontStyle,
        sidebarFontSelect: formState.sidebarFontStyle,
      });

      if (response.status === 200) {
        refetch();
      } else {
        throw new Error("Failed to update settings");
      }
    } catch (error) {
      console.error("Error updating settings:", error);
    }
  };

  return (
    <div className="tab-pane fade firm-settings-user-perms-fs active show">
      <div className="d-flex justify-content-between">
        <h2 className="fw-bold">Client Portal Font And Color</h2>
        <div
          onClick={() => {
            handleHintToggle();
          }}
        >
          <i className="ic ic-19 ic-help-2 cursor-pointer" />
        </div>
      </div>
      <div className="mt-3 w-50">
        <div className="d-flex gap-1">
          <div className="col-6">
            <label htmlFor="headerFontSelect">Select Header Font:</label>
            <select
              className="form-control py-0 height-25"
              id="headerFontSelect"
              name="headerFontStyle"
              value={formState.headerFontStyle}
              onChange={handleInputChange}
            >
              {FontSettings.map((font) => (
                <option key={font.id} value={font.name}>
                  {font.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-6">
            <label htmlFor="sidebarFontSelect">Select Sidebar Font:</label>
            <select
              className="form-control py-0 height-25"
              id="sidebarFontSelect"
              name="sidebarFontStyle"
              value={formState.sidebarFontStyle}
              onChange={handleInputChange}
            >
              {FontSettings.map((font) => (
                <option key={font.id} value={font.name}>
                  {font.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="mt-3 col-6">
          <label htmlFor="colorPicker">Select Background Color:</label>
          <input
            type="color"
            id="colorPicker"
            className="form-control height-25"
            style={{ paddingTop: "2px", paddingBottom: "2px" }}
            name="brandColor"
            value={formState.brandColor}
            onChange={handleInputChange}
          />
        </div>

        <div className="mt-3 ps-3">
          <button
            onClick={handleSubmit}
            className="btn btn-primary d-flex align-items-center height-25"
          >
            Save Changes
          </button>
        </div>
      </div>
      {showHints && <HintModal show={showHints} handleClose={handleHintToggle} points={points} />}
    </div>
  );
};

export default ClientPortal;
